import React from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-sage-800 text-cream-200">
      <div className="max-w-6xl mx-auto px-6 py-10">

        {/* Main grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-8">

          {/* Brand */}
          <div className="text-center sm:text-left">
            <h4 className="font-display text-white text-base mb-3">Stewart's Sweet Shells</h4>
            <p className="text-sm text-cream-300 mt-3 leading-relaxed">
              Pre-Order Today<br />
              Pickup Saturday & Sunday
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h4 className="font-display text-white text-base mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              {[
                ["/", "Home"],
                ["/menu", "Menu"],
                ["/order", "Order Online"],
                ["/about", "About"],
                ["/faq", "FAQ"],
                ["/reviews", "Leave a Review"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-cream-300 hover:text-white transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center sm:text-right">
            <h4 className="font-display text-white text-base mb-3">Get In Touch</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:hello@stewartsweetshells.com"
                  className="inline-flex items-center gap-2 text-cream-300 hover:text-white transition-colors"
                >
                  <Mail size={14} />
                  hello@stewartsweetshells.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/stewartsweetshells"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-cream-300 hover:text-white transition-colors"
                >
                  <Instagram size={14} />
                  @stewartsweetshells
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Divider + copyright */}
        <div className="border-t border-sage-700 pt-5 text-center text-xs text-cream-400">
          © {new Date().getFullYear()} Stewart's Sweet Shells · All Rights Reserved · Aubrey, TX
        </div>
      </div>
    </footer>
  );
}

